import "@/styles/index.scss";
import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import filters from "../src/filters";
import store from "./store";
import JsEncrypt from "./utils/jsencrypt";
import VueI18n from "vue-i18n";
import languages from "./languages";
import locale from "element-ui/lib/locale";



console.log("lastUpdate0827-internet-declare");
Vue.use(VueI18n);
Vue.prototype.$jsEncrypt = JsEncrypt;
Vue.config.productionTip = false;
router.beforeEach((to, from, next) => {
  // 当移动端试图访问pc端页面时
  if (/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i.test(navigator.userAgent) && to.meta.type !== "mobile") {
    next("/mobile");
    return;
  }
  // 当pc端试图访问移动端页面时
  if (!/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i.test(navigator.userAgent) && to.meta.type !== "pc") {
    next("/pc");
    return;
  }
  next();
});
Object.keys(filters).forEach(key => {
  Vue.filter(key, filters[key]);
});
const i18n = new VueI18n({
  locale: store.state.language,
  messages: languages
});
locale.i18n((key, value) => i18n.t(key, value));

new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount("#app");